module.exports = __webpack_public_path__ + "media/images/rank/bronze-383ca6b64764496b7b2f53b0fc805f91.png";